import {
  ADD_WHITELABELS,
  ADD_WHITELABELS_SUCCESS,
  ADD_WHITELABELS_FAILURE,
} from "../actionTypes";

export const addWhitelabels = (payload) => ({
  type: ADD_WHITELABELS,
  payload,
});

export const addWhitelabelsSuccess = (payload) => ({
  type: ADD_WHITELABELS_SUCCESS,
  payload,
});

export const addWhitelabelsFailure = () => ({
  type: ADD_WHITELABELS_FAILURE,
});
